export enum FileTypeEnum {
    folder,
    file
}